[
  {
    "code": "BJ-AL",
    "name": "Alibori"
  },
  {
    "code": "BJ-AK",
    "name": "Atakora"
  },
  {
    "code": "BJ-AQ",
    "name": "Atlantique"
  },
  {
    "code": "BJ-BO",
    "name": "Borgou"
  },
  {
    "code": "BJ-CO",
    "name": "Collines"
  },
  {
    "code": "BJ-DO",
    "name": "Donga"
  },
  {
    "code": "BJ-KO",
    "name": "Kouffo"
  },
  {
    "code": "BJ-LI",
    "name": "Littoral"
  },
  {
    "code": "BJ-MO",
    "name": "Mono"
  },
  {
    "code": "BJ-OU",
    "name": "Ouémé"
  },
  {
    "code": "BJ-PL",
    "name": "Plateau"
  },
  {
    "code": "BJ-ZO",
    "name": "Zou"
  }
]